const qmsCategoryEndpoints = {
  CATEGORIES: 'loopay-qms-management/qms-document-categories',
  TAGS: 'loopay-qms-management/qms-document-categories/tags',
} as const;

export default qmsCategoryEndpoints;
